import React from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";

import DetalleCard from "~business/Cards/DetalleCard";

import PhotoIcon from "@mui/icons-material/Photo";
import { setDocumentosFileName, setIsProcessingDocumentos } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import ItemMultipleFileUploaderCard from "~business/Cards/ItemMultipleFileUploaderCard";
import { ArchivoQuitadoEvent, ArchivosAgregadosEvent } from "../../../types";

const useStyles = makeStyles((theme: any) => ({
  impresosDisabled: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.38,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#8B8B8B",
    paddingTop: "5%",
  },
}));

const title = "Documentación";

interface SliceDocumentacion {
  documentos: string[];
}

const useReduxSelector = () =>
  useSelector<any, SliceDocumentacion>((state) => {
    return { documentos: state.cargaSiniestroReducer.documentosSelected };
  });

interface DocumentacionCardProps {
  isLoading?: boolean;
  disabled?: boolean;
}

const DocumentacionCard = ({ isLoading, disabled }: DocumentacionCardProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { documentos } = useReduxSelector();

  if (isLoading)
    return (
      <DetalleCard isLoading={isLoading} title={title} IconHeader={PhotoIcon} />
    );

  const handleAdded = (event: ArchivosAgregadosEvent) => {
    const value = event.target.value.map((doc) => `temp/${doc}`);
    dispatch(setDocumentosFileName(value));
  };

  const handleRemoved = (event: ArchivoQuitadoEvent) => {
    const value = `temp/${event.target.value}`;
    const fotos = documentos.filter((doc) => doc !== value);
    dispatch(setDocumentosFileName(fotos));
  };

  const handleProcessingDocumentos = (value: boolean) => {
    dispatch(setIsProcessingDocumentos(value));
  };

  return (
    <DetalleCard isLoading={isLoading} title={title} IconHeader={PhotoIcon}>
      {disabled && (
        <Typography className={classes.impresosDisabled}>
          {"Se requiere ingresar Número de Póliza para cargar Documentación"}
        </Typography>
      )}
      {!disabled && (
        <>
          <ItemMultipleFileUploaderCard
            label={"Documentos"}
            onAdded={(event) => handleAdded(event as ArchivosAgregadosEvent)}
            onRemoved={(event) => handleRemoved(event as ArchivoQuitadoEvent)}
            onProcessStart={handleProcessingDocumentos}
            acceptImage={true}
            acceptPdf={true}
            multiple={true}
          />
        </>
      )}
    </DetalleCard>
  );
};

export default DocumentacionCard;
